import React from "react";
import "./styles.css";

const ProgressBar = ({ timer }) => {
	const containerStyles = {
		height: 20,
		width: "100%",
		backgroundColor: "rgba(255, 255, 255, 0.1)",
		borderRadius: 50,
		margin: 50
	};

	const fillerStyles = {
		height: "100%",
		width: "100%",
		transition: "width 8s linear",
		backgroundColor: "rgb(209, 236, 248)",
		borderRadius: "inherit",
		textAlign: "right",
		border: "1px solid #6ecbf5",
		boxShadow:
			"0 0 15px #6ecbf5, 0 0 15px #6ecbf5, 0 0 15px #6ecbf5, 0 0 15px #6ecbf5, 0 0 15px #6ecbf5, 0 0 15px #6ecbf5, 0 0 15px #6ecbf5",
		animation: `timer ${timer}s linear`,
		animationFillMode: "forwards"
	};

	return (
		<div style={containerStyles}>
			<div style={fillerStyles}>
				<span></span>
			</div>
		</div>
	);
};

export default ProgressBar;
